import { render, staticRenderFns } from "./GrupoEmpresarialView.vue?vue&type=template&id=35e4ccae"
import script from "./GrupoEmpresarialView.vue?vue&type=script&lang=js"
export * from "./GrupoEmpresarialView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports